import { render, staticRenderFns } from "./detail_habeas_data.vue?vue&type=template&id=25a7aa70&scoped=true"
import script from "./detail_habeas_data.vue?vue&type=script&lang=js"
export * from "./detail_habeas_data.vue?vue&type=script&lang=js"
import style0 from "./detail_habeas_data.vue?vue&type=style&index=0&id=25a7aa70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7aa70",
  null
  
)

export default component.exports